export default __webpack_public_path__ + "img/clock.df9d4446.svg";